import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import authService from '../services/authService';
import './LoginPage.css';

export default function ActivationPage() {
  const { uid, token } = useParams();
  const attempted = useRef(false);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    if (!uid || !token) {
      setStatus('error');
      return;
    }

    authService.activate({ uid, token })
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [uid, token]);

  return (
    <div className="login-page">
      <div className="card login-page__card">
        {status === 'loading' ? (
          <>
            <div className="login-page__eyebrow">ProfitFactor workspace</div>
            <h1 className="login-page__title">Activating your account…</h1>
            <p className="login-page__description">Please wait while we verify your email address.</p>
          </>
        ) : null}

        {status === 'success' ? (
          <>
            <div className="login-page__eyebrow">Email verified</div>
            <h1 className="login-page__title">Your account is ready</h1>
            <p className="login-page__description">Your email has been verified. Sign in to open your workspace.</p>
            <Link to="/login" className="login-page__submit">Go to sign in</Link>
          </>
        ) : null}

        {status === 'error' ? (
          <>
            <div className="login-page__eyebrow">Activation problem</div>
            <h1 className="login-page__title">We couldn’t activate your account</h1>
            <p className="login-page__description">The link may be invalid or expired. Please create a new account or contact support.</p>
            <Link to="/signup" className="login-page__submit">Back to sign up</Link>
          </>
        ) : null}
      </div>
    </div>
  );
}
